import { render, staticRenderFns } from "./info-component.vue?vue&type=template&id=2f3de767"
import script from "./info-component.vue?vue&type=script&lang=js"
export * from "./info-component.vue?vue&type=script&lang=js"
import style0 from "./info-component.vue?vue&type=style&index=0&id=2f3de767&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports